import { NavItem } from "./types.js";

export function isNavItem(v: NavItem | unknown): v is NavItem {
  return !!v && typeof v === "object" && "route" in v;
}
